import { getCountry } from 'utils/country';
import countries from 'constants/countries';

export const getEDPCountry = () => {
  const country = getCountry();

  switch (country) {
    case countries.US:
      return 'United States';
    case countries.UK:
      return 'United Kingdom';
    case countries.FR:
      return 'France';
    case countries.EU:
      return 'Europe';
    case countries.DE:
      return 'Germany';
    default:
      throw Error('getEDPCountry was called with a non existing country ' + country);
  }
};
